/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Tame_Mule_SparkInputs */

const en_flat_tame_mule_spark = /** @type {(inputs: Flat_Tame_Mule_SparkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const de_flat_tame_mule_spark = /** @type {(inputs: Flat_Tame_Mule_SparkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Flat_Tame_Mule_SparkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_tame_mule_spark = /** @type {((inputs?: Flat_Tame_Mule_SparkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Tame_Mule_SparkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_tame_mule_spark(inputs)
	return de_flat_tame_mule_spark(inputs)
});